import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed-top container-width" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = {
  class: "d-flex w-100 position-absolute bold",
  style: {"z-index":"100"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "leftPart"),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title", {}, () => [
          _createTextVNode("eHoaDon Online")
        ])
      ]),
      _renderSlot(_ctx.$slots, "rightPart")
    ], 512), [
      [_vShow, !_ctx.hideNavigationItem]
    ]),
    _renderSlot(_ctx.$slots, "overlapHeader")
  ]))
}